// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings_txzT9 {
	display: inline-flex;
	height: 100%;
	width: 100%;
	background: var(--white-color);

	.left_dZZHa {
		height: 100%;
		width: 220px;
		min-width: 220px;
		overflow-y: scroll;
		padding: 0px;
		background: var(--fa-background);
		border-radius: 8px;
		overflow-x: hidden;

		&::-webkit-scrollbar {
			display: none;
		}

		ul {
			margin: 0px;
			width: 100%;
			display: inline-flex;
			flex-direction: column;
			padding-left: 0px;

			ud {
				display: inline-flex;
				flex-direction: column;
				padding: 10px;
			}

			ld,
			li {
				padding: 12px 5px;
				font-size: 12px;
				font-weight: 400;
				cursor: pointer;
			}

			li {
				width: 94%;
				color: var(--_3c3a3a-color);
				border-radius: 0px 20px 20px 0px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: 14px;
				font-weight: 600;

				svg {
					min-width: 15px;
					min-height: 15px;
					width: 15px;
					height: 15px;
				}

				&.active_EC3UT {
					/* background: var(--_16c0982e-background); */
					color: var(--_10a37f-background);

					svg {
						color: var(--_10a37f-background);
					}
				}

				&:hover {
					background: var(--_16c0982e-background);
					color: var(--_10a37f-background);

					svg {
						color: var(--_10a37f-background);
					}
				}
			}

			ld {
				font-size: 12px;
				font-weight: 400;
				border-left: 2px solid var(--_16c0982e-background);
				border-radius: 0px 8px 9px 0px;
				font-size: 14px;
				font-weight: 500;


				&:hover {
					background: var(--_16c0982e-background);
				}

				&.active_EC3UT {
					font-weight: 700;
					color: var(--_10a37f-background);
					background: var(--_16c0982e-background);
					border-left: 2px solid var(--_10a37f-background);
				}
			}
		}
	}

	.right_ToPus {
		width: calc(100% - 200px);
		height: 100%;
		overflow-y: scroll;
		overflow-x: hidden;

		.content_UHwvM {
			min-width: 400px;
			width: 60%;
			border-top: 1px solid var(--border-color);
			border-bottom: 1px solid var(--border-color);
			margin: 0 auto;
			padding: 20px;
			display: inline-flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 10px;

			.container_s2PgD {
				width: 100%;
				display: inline-flex;
				flex-direction: column;
				gap: 4px;
			}

			.small_BDCAu {
				font-size: 12px;
				font-weight: 400;

				a {
					cursor: pointer;
					-webkit-user-select: none;
					        user-select: none;
				}
			}

			.input_dCP0y {
				display: inline-flex;
				flex-direction: column;
				gap: 2px;
				background: var(--f5-background);
				border-radius: 4px;
				min-width: 320px;
				position: relative;
				padding: 4px 12px;

				svg {
					min-width: 14px;
					min-height: 14px;
					width: 14px;
					height: 14px;
				}

				label {
					font-size: 10px;
					font-weight: 600;
					line-height: 0px;
					margin-top: 8px;
				}

				input {
					width: 100%;
					background: transparent;
					outline: none;
					border: none;
					font-family: inherit;
					font-size: 14px;
				}

				textarea {
					background: transparent;
					border: none;
					outline: none;
					resize: none;
				}

				div {
					display: flex;
					align-items: center;
					justify-content: space-between;

					svg {
						min-width: 14px;
						min-height: 14px;
					}
				}

				ul {
					display: inline-flex;
					display: none;
					width: 100%;
					top: 0px;
					flex-direction: column;
					position: absolute;
				}

				li {
					padding: 4px 12px;
					background: var(--f5-background);
				}
			}

			.title_ATVjC {
				font-size: 22px;
				font-weight: 300;
				color: var(--_3c3a3a-color);
			}

		

			.list_CKXxE {
				width: 100%;
				display: inline-flex;
				flex-direction: column;
				align-items: center;
				gap: 10px;

				li {
					width: 100%;
					padding: 4px 8px;
				}
			}

			.notification_ykzvx {
				display: flex;
				flex-direction: column;
				gap: 5px;
				padding-left: 0px;

				li {
					display: inline-flex;
					align-items: center;
					gap: 10px;

					div {
						padding: 6px;
						font-size: 14px;
						font-weight: 600;
					}
				}
			}

			.access_cyD1j {
				display: inline-flex;
				flex-direction: column;
				align-items: center;
				gap: 10px;
			}

		

			.events_AR8Cp {
				display: inline-flex;
				flex-direction: column;
				gap: 4px;
				padding-left: 2px;
				li {
					display: inline-flex;
					align-items: center;
					justify-content: space-between;
					border-bottom: 1px solid var(--border-color);
					padding: 6px;
					gap: 10px;
					background: var(--white-color);

					>div {
						display: inline-flex;
						flex-direction: column;
						gap: 4px;

						b {
							color: var(--_3c3a3a-color);
							font-size: 14px;
							font-weight: 500;
						}

						p {
							font-size: 14px;
							font-weight: 500;
						}
					}

					button {
						padding: 4px 12px;
						border-radius: 4px;
						background: var(--_10a37f-background);
						color: var(--_10a37f-background);
						font-size: 12px;

						&:hover {
							background: var(--_16c098-background);
						}
					}
				}
			}

			.checkbox_lCruV {
				display: inline-flex;
				align-items: center;
				position: relative;
				font-size: 12px;
			}

			input[type='checkbox'] {
				appearance: none;
				border: 2px solid var(--border-color);
				border-radius: 4px;
				width: 14px;
				height: 14px;
				cursor: pointer;
				outline: none;
				margin-right: 8px;
				position: relative;
				z-index: 1;
			}

			input[type='checkbox']:checked {
				background-color: var(--_10a37f-background);
				border-color: var(--_10a37f-background);
			}

			input[type='checkbox']::before {
				content: '\\2713';
				font-size: 9px;
				color: white;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				z-index: 2;
				opacity: 0;
				transition: opacity 0.2s ease-in-out;
			}

			input[type='checkbox']:checked::before {
				opacity: 1;
			}

			.button__gPG7 {
				min-width: 230px;
				padding: 10px 10px;
				cursor: pointer;
				display: inline-flex;
				justify-content: center;
				align-items: center;
				gap: 8px;

				&.files_SxDQf {
					color: var(--white-color);
					cursor: pointer;
					width: 320px;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					gap: 10px;
					-webkit-user-select: none;
					        user-select: none;
					background: var(--_16c098-color);
					border-radius: 4px;

					&:hover {
						background: var(--_16c09821-background);
					}

					p {
						margin: 0px;
					}
				}

				&.copy_EWv9b {
					color: var(--_10a37f-background);
					border-radius: 4px;
				}

				&.stripe_S3HQJ {
					border: 1px solid var(--_10a37f-background);
					border-radius: 4px;

					strong {
						color: var(--_10a37f-background);
					}
				}

				&.inactive_ed3Kc {
					border: 1px solid var(--_10a37f-background);
                    border-radius: 4px;
                    background: transparent;
                    color: var(--_10a37f-background);
                    opacity: 0.5;
				}

				&.active_EC3UT {
					border: 1px solid var(--_10a37f-background);
					background: transparent;
					color: var(--_10a37f-background);
					border-radius: 4px;
				}
			}

			a {
				color: var(--_10a37f-background);
				text-decoration: underline;
			}
		}
	}
}




.customButton_oq6G4 {
	width: 320px;
	height: 40px;
	border: none;
	cursor: pointer;
	-webkit-user-select: none;
	user-select: none;
	color: var(--white-color);
	background: var(--_16c098-color);
	border-radius: 4px;

	&:hover {
		background: var(--_16c09821-background);
	}
}

.customButtonOutlined_Oy1Dc {
	width: 320px;
	height: 40px;
	cursor: pointer;
	-webkit-user-select: none;
	user-select: none;
	color: var(--e6fff9-background);
	border: none;
	background: var(--_16c098-color);
	border-radius: 4px;

	&:hover {
		border: 1px solid var(--_16c098-background);
		color: var(--_16c098-background);
	}
}

.meeting_KHNWP {
	position: relative;
	display: flex;
	align-items: flex-start;
	align-items: center;
	flex-direction: column;
	gap: 4px;
	height: 45px;
	width: 100%;

	b {
		font-size: 12px;
		font-weight: 500;
	}

	.input_dCP0y {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 4px;
		justify-content: center;
		height: 100%;
		background: var(--border-color);
		border-radius: 6px;
		padding: 4px 8px;

		svg {
			min-height: 16px;
			min-width: 16px;
			width: 16px;
		}

		input {
			width: 100%;
			font-size: 16px;
			background: transparent;
		}
	}
}


.calendarsList_GAgkr {
	display: inline-flex;
	flex-direction: column;
	color: var(--_3c3a3a-color);
	gap: 2px;

	li {
		display: inline-flex;
		align-items: center;
		gap: 4px;

		.dot_PTLlX {
			min-width: 12px;
			min-height: 12px;
			border-radius: 50%;
			background: var(--_16c0982e-background);
		}

		span {
			font-size: 12px;
			font-weight: 500;
		}
	}
}

.calendarCheckbox_Tbafu {
	color: var(--_16c098-color);
}

.downloadIcon_pVwQz {
	font-size: 20px;
	color: var(--f5-background);
}

.mainColorIcon_qpFFG {
	font-size: 16px;
	color: var(--_10a37f-background);
}

.checkboxIcon_pUjW0 {
	color: var(--e6fff9-background);
}

.checkedButton_jR8Hv {
	padding: 3px;
	border-radius: 50%;
	transition:
		background-color 0.2s ease-in-out,
		transform 0.2s ease-in-out;
	animation: checkboxCheckedAnimation__gCNz 0.25s ease;

	&:hover {
		background-color: var(--f5-background);
	}
}

.removeIcon_PnseX {
	cursor: pointer;
	transition: transform 0.2s ease-in-out;
}

.removeIcon_PnseX:hover {
	transform: scale(1.1);
}

.uncheckedButton_V3HQy {
	border: none;
	background: transparent;
	padding: 3px;
	border-radius: 50%;
	transition:
		background-color 0.2s ease-in-out,
		transform 0.2s ease-in-out;
	animation: checkboxUncheckedAnimation_E4c1F 0.25s ease;

	&:hover {
		background-color: var(--f5-background);
	}
}

@keyframes checkboxCheckedAnimation__gCNz {
	0% {
		transform: scale(0.85);
	}

	50% {
		transform: scale(1.1);
	}

	100% {
		transform: scale(1);
	}
}

@keyframes checkboxUncheckedAnimation_E4c1F {
	0% {
		transform: scale(1);
	}

	50% {
		transform: scale(1.1);
	}

	100% {
		transform: scale(0.85);
	}
}

.checkboxWithInputContainer_CFsU9 {
	display: flex;
	gap: 10px;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
}

.numberInputCheckbox_Qo5Eh {
	background-color: var(--f5-background);
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	outline: none;
	height: 45px;
	width: 70px;
	color: #666;
	font-size: 18px;
	padding: 0px 10px;
	text-decoration: none;
}

.saveButton_Ko8lj {
	background-color: var(--_16c098-color);
	width: 140px;
	height: 40px;
	border: none;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--white-color);
	cursor: pointer;
	-webkit-user-select: none;
	user-select: none;
	transition: background 0.2s ease-in-out;

	&:hover {
		background: var(--_16c09821-background);
	}
}

.submitButton_QdYA0 {
	background-color: var(--_16c09821-background) !important;
	border: none;
	border-radius: 5px;
	color: var(--white-color);
	padding: 10px 20px;
	cursor: pointer;
	font-size: 16px;
	position: relative;
	overflow: hidden;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	transition: background-color 0.3s ease;
}

.calendarAsPublicContent_YvKyq {
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;
}

.submitButton_QdYA0.sent_DVNwW {
	background-color: var(--_16c098-background) !important;
}

.text_DcHeX {
	transition:
		opacity 0.5s ease,
		transform 0.5s ease;
	opacity: 1;
	transform: translateY(0);
}

.icon_a6HWu {
	position: absolute;
	opacity: 0;
	transform: translateY(-20px);
	transition:
		opacity 0.5s ease,
		transform 0.5s ease;
}

.submitButton_QdYA0.sent_DVNwW .text_DcHeX {
	opacity: 0;
	transform: translateY(20px);
}

.submitButton_QdYA0.sent_DVNwW .icon_a6HWu {
	opacity: 1;
	transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/settings.module.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB;CACpB,YAAY;CACZ,WAAW;CACX,8BAA8B;;CAE9B;EACC,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;;EAElB;GACC,aAAa;EACd;;EAEA;GACC,WAAW;GACX,WAAW;GACX,oBAAoB;GACpB,sBAAsB;GACtB,iBAAiB;;GAEjB;IACC,oBAAoB;IACpB,sBAAsB;IACtB,aAAa;GACd;;GAEA;;IAEC,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;GAChB;;GAEA;IACC,UAAU;IACV,2BAA2B;IAC3B,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;;IAEhB;KACC,eAAe;KACf,gBAAgB;KAChB,WAAW;KACX,YAAY;IACb;;IAEA;KACC,6CAA6C;KAC7C,gCAAgC;;KAEhC;MACC,gCAAgC;KACjC;IACD;;IAEA;KACC,uCAAuC;KACvC,gCAAgC;;KAEhC;MACC,gCAAgC;KACjC;IACD;GACD;;GAEA;IACC,eAAe;IACf,gBAAgB;IAChB,kDAAkD;IAClD,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;;;IAGhB;KACC,uCAAuC;IACxC;;IAEA;KACC,gBAAgB;KAChB,gCAAgC;KAChC,uCAAuC;KACvC,gDAAgD;IACjD;GACD;EACD;CACD;;CAEA;EACC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;;EAElB;GACC,gBAAgB;GAChB,UAAU;GACV,yCAAyC;GACzC,4CAA4C;GAC5C,cAAc;GACd,aAAa;GACb,oBAAoB;GACpB,sBAAsB;GACtB,2BAA2B;GAC3B,uBAAuB;GACvB,SAAS;;GAET;IACC,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;GACT;;GAEA;IACC,eAAe;IACf,gBAAgB;;IAEhB;KACC,eAAe;KACf,yBAAiB;aAAjB,iBAAiB;IAClB;GACD;;GAEA;IACC,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;;IAEjB;KACC,eAAe;KACf,gBAAgB;KAChB,WAAW;KACX,YAAY;IACb;;IAEA;KACC,eAAe;KACf,gBAAgB;KAChB,gBAAgB;KAChB,eAAe;IAChB;;IAEA;KACC,WAAW;KACX,uBAAuB;KACvB,aAAa;KACb,YAAY;KACZ,oBAAoB;KACpB,eAAe;IAChB;;IAEA;KACC,uBAAuB;KACvB,YAAY;KACZ,aAAa;KACb,YAAY;IACb;;IAEA;KACC,aAAa;KACb,mBAAmB;KACnB,8BAA8B;;KAE9B;MACC,eAAe;MACf,gBAAgB;KACjB;IACD;;IAEA;KACC,oBAAoB;KACpB,aAAa;KACb,WAAW;KACX,QAAQ;KACR,sBAAsB;KACtB,kBAAkB;IACnB;;IAEA;KACC,iBAAiB;KACjB,gCAAgC;IACjC;GACD;;GAEA;IACC,eAAe;IACf,gBAAgB;IAChB,2BAA2B;GAC5B;;;;GAIA;IACC,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;;IAET;KACC,WAAW;KACX,gBAAgB;IACjB;GACD;;GAEA;IACC,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;;IAEjB;KACC,oBAAoB;KACpB,mBAAmB;KACnB,SAAS;;KAET;MACC,YAAY;MACZ,eAAe;MACf,gBAAgB;KACjB;IACD;GACD;;GAEA;IACC,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;GACV;;;;GAIA;IACC,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB;KACC,oBAAoB;KACpB,mBAAmB;KACnB,8BAA8B;KAC9B,4CAA4C;KAC5C,YAAY;KACZ,SAAS;KACT,8BAA8B;;KAE9B;MACC,oBAAoB;MACpB,sBAAsB;MACtB,QAAQ;;MAER;OACC,2BAA2B;OAC3B,eAAe;OACf,gBAAgB;MACjB;;MAEA;OACC,eAAe;OACf,gBAAgB;MACjB;KACD;;KAEA;MACC,iBAAiB;MACjB,kBAAkB;MAClB,qCAAqC;MACrC,gCAAgC;MAChC,eAAe;;MAEf;OACC,qCAAqC;MACtC;KACD;IACD;GACD;;GAEA;IACC,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;GAChB;;GAEA;IAGC,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;GACX;;GAEA;IACC,2CAA2C;IAC3C,uCAAuC;GACxC;;GAEA;IACC,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,UAAU;IACV,oCAAoC;GACrC;;GAEA;IACC,UAAU;GACX;;GAEA;IACC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;;IAER;KACC,yBAAyB;KACzB,eAAe;KACf,YAAY;KACZ,aAAa;KACb,2BAA2B;KAC3B,mBAAmB;KACnB,SAAS;KACT,yBAAiB;aAAjB,iBAAiB;KACjB,gCAAgC;KAChC,kBAAkB;;KAElB;MACC,uCAAuC;KACxC;;KAEA;MACC,WAAW;KACZ;IACD;;IAEA;KACC,gCAAgC;KAChC,kBAAkB;IACnB;;IAEA;KACC,2CAA2C;KAC3C,kBAAkB;;KAElB;MACC,gCAAgC;KACjC;IACD;;IAEA;KACC,2CAA2C;oBAC5B,kBAAkB;oBAClB,uBAAuB;oBACvB,gCAAgC;oBAChC,YAAY;IAC5B;;IAEA;KACC,2CAA2C;KAC3C,uBAAuB;KACvB,gCAAgC;KAChC,kBAAkB;IACnB;GACD;;GAEA;IACC,gCAAgC;IAChC,0BAA0B;GAC3B;EACD;CACD;AACD;;;;;AAKA;CACC,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,iBAAiB;CACjB,yBAAyB;CACzB,gCAAgC;CAChC,kBAAkB;;CAElB;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,iBAAiB;CACjB,+BAA+B;CAC/B,YAAY;CACZ,gCAAgC;CAChC,kBAAkB;;CAElB;EACC,2CAA2C;EAC3C,gCAAgC;CACjC;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;CACtB,QAAQ;CACR,YAAY;CACZ,WAAW;;CAEX;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;;EAEhB;GACC,gBAAgB;GAChB,eAAe;GACf,WAAW;EACZ;;EAEA;GACC,WAAW;GACX,eAAe;GACf,uBAAuB;EACxB;CACD;AACD;;;AAGA;CACC,oBAAoB;CACpB,sBAAsB;CACtB,2BAA2B;CAC3B,QAAQ;;CAER;EACC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;;EAER;GACC,eAAe;GACf,gBAAgB;GAChB,kBAAkB;GAClB,uCAAuC;EACxC;;EAEA;GACC,eAAe;GACf,gBAAgB;EACjB;CACD;AACD;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB;;4BAE2B;CAC3B,oDAA8C;;CAE9C;EACC,sCAAsC;CACvC;AACD;;AAEA;CACC,eAAe;CACf,sCAAsC;AACvC;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,YAAY;CACZ,kBAAkB;CAClB;;4BAE2B;CAC3B,sDAAgD;;CAEhD;EACC,sCAAsC;CACvC;AACD;;AAEA;CACC;EACC,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;CACtC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,WAAW;CACX,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,sCAAsC;CACtC,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,eAAe;CACf,yBAAyB;CACzB,iBAAiB;CACjB,uCAAuC;;CAEvC;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,wDAAwD;CACxD,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,sCAAsC;AACvC;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,sDAAsD;AACvD;;AAEA;CACC;;qBAEoB;CACpB,UAAU;CACV,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,4BAA4B;CAC5B;;qBAEoB;AACrB;;AAEA;CACC,UAAU;CACV,2BAA2B;AAC5B;;AAEA;CACC,UAAU;CACV,wBAAwB;AACzB","sourcesContent":[".settings {\n\tdisplay: inline-flex;\n\theight: 100%;\n\twidth: 100%;\n\tbackground: var(--white-color);\n\n\t.left {\n\t\theight: 100%;\n\t\twidth: 220px;\n\t\tmin-width: 220px;\n\t\toverflow-y: scroll;\n\t\tpadding: 0px;\n\t\tbackground: var(--fa-background);\n\t\tborder-radius: 8px;\n\t\toverflow-x: hidden;\n\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\tul {\n\t\t\tmargin: 0px;\n\t\t\twidth: 100%;\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tpadding-left: 0px;\n\n\t\t\tud {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tpadding: 10px;\n\t\t\t}\n\n\t\t\tld,\n\t\t\tli {\n\t\t\t\tpadding: 12px 5px;\n\t\t\t\tfont-size: 12px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\tli {\n\t\t\t\twidth: 94%;\n\t\t\t\tcolor: var(--_3c3a3a-color);\n\t\t\t\tborder-radius: 0px 20px 20px 0px;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 600;\n\n\t\t\t\tsvg {\n\t\t\t\t\tmin-width: 15px;\n\t\t\t\t\tmin-height: 15px;\n\t\t\t\t\twidth: 15px;\n\t\t\t\t\theight: 15px;\n\t\t\t\t}\n\n\t\t\t\t&.active {\n\t\t\t\t\t/* background: var(--_16c0982e-background); */\n\t\t\t\t\tcolor: var(--_10a37f-background);\n\n\t\t\t\t\tsvg {\n\t\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t\tcolor: var(--_10a37f-background);\n\n\t\t\t\t\tsvg {\n\t\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tld {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tborder-left: 2px solid var(--_16c0982e-background);\n\t\t\t\tborder-radius: 0px 8px 9px 0px;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t}\n\n\t\t\t\t&.active {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t\tborder-left: 2px solid var(--_10a37f-background);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.right {\n\t\twidth: calc(100% - 200px);\n\t\theight: 100%;\n\t\toverflow-y: scroll;\n\t\toverflow-x: hidden;\n\n\t\t.content {\n\t\t\tmin-width: 400px;\n\t\t\twidth: 60%;\n\t\t\tborder-top: 1px solid var(--border-color);\n\t\t\tborder-bottom: 1px solid var(--border-color);\n\t\t\tmargin: 0 auto;\n\t\t\tpadding: 20px;\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: flex-start;\n\t\t\talign-items: flex-start;\n\t\t\tgap: 10px;\n\n\t\t\t.container {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 4px;\n\t\t\t}\n\n\t\t\t.small {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tfont-weight: 400;\n\n\t\t\t\ta {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tuser-select: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.input {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 2px;\n\t\t\t\tbackground: var(--f5-background);\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tmin-width: 320px;\n\t\t\t\tposition: relative;\n\t\t\t\tpadding: 4px 12px;\n\n\t\t\t\tsvg {\n\t\t\t\t\tmin-width: 14px;\n\t\t\t\t\tmin-height: 14px;\n\t\t\t\t\twidth: 14px;\n\t\t\t\t\theight: 14px;\n\t\t\t\t}\n\n\t\t\t\tlabel {\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tline-height: 0px;\n\t\t\t\t\tmargin-top: 8px;\n\t\t\t\t}\n\n\t\t\t\tinput {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\toutline: none;\n\t\t\t\t\tborder: none;\n\t\t\t\t\tfont-family: inherit;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t}\n\n\t\t\t\ttextarea {\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\tborder: none;\n\t\t\t\t\toutline: none;\n\t\t\t\t\tresize: none;\n\t\t\t\t}\n\n\t\t\t\tdiv {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: space-between;\n\n\t\t\t\t\tsvg {\n\t\t\t\t\t\tmin-width: 14px;\n\t\t\t\t\t\tmin-height: 14px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tul {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\tdisplay: none;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\ttop: 0px;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t}\n\n\t\t\t\tli {\n\t\t\t\t\tpadding: 4px 12px;\n\t\t\t\t\tbackground: var(--f5-background);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.title {\n\t\t\t\tfont-size: 22px;\n\t\t\t\tfont-weight: 300;\n\t\t\t\tcolor: var(--_3c3a3a-color);\n\t\t\t}\n\n\t\t\n\n\t\t\t.list {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 10px;\n\n\t\t\t\tli {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tpadding: 4px 8px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.notification {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 5px;\n\t\t\t\tpadding-left: 0px;\n\n\t\t\t\tli {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 10px;\n\n\t\t\t\t\tdiv {\n\t\t\t\t\t\tpadding: 6px;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.access {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 10px;\n\t\t\t}\n\n\t\t\n\n\t\t\t.events {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 4px;\n\t\t\t\tpadding-left: 2px;\n\t\t\t\tli {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\tborder-bottom: 1px solid var(--border-color);\n\t\t\t\t\tpadding: 6px;\n\t\t\t\t\tgap: 10px;\n\t\t\t\t\tbackground: var(--white-color);\n\n\t\t\t\t\t>div {\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\tgap: 4px;\n\n\t\t\t\t\t\tb {\n\t\t\t\t\t\t\tcolor: var(--_3c3a3a-color);\n\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\tp {\n\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\tbutton {\n\t\t\t\t\t\tpadding: 4px 12px;\n\t\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\t\tfont-size: 12px;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: var(--_16c098-background);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.checkbox {\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\talign-items: center;\n\t\t\t\tposition: relative;\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\n\t\t\tinput[type='checkbox'] {\n\t\t\t\t-webkit-appearance: none;\n\t\t\t\t-moz-appearance: none;\n\t\t\t\tappearance: none;\n\t\t\t\tborder: 2px solid var(--border-color);\n\t\t\t\tborder-radius: 4px;\n\t\t\t\twidth: 14px;\n\t\t\t\theight: 14px;\n\t\t\t\tcursor: pointer;\n\t\t\t\toutline: none;\n\t\t\t\tmargin-right: 8px;\n\t\t\t\tposition: relative;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\n\t\t\tinput[type='checkbox']:checked {\n\t\t\t\tbackground-color: var(--_10a37f-background);\n\t\t\t\tborder-color: var(--_10a37f-background);\n\t\t\t}\n\n\t\t\tinput[type='checkbox']::before {\n\t\t\t\tcontent: '\\2713';\n\t\t\t\tfont-size: 9px;\n\t\t\t\tcolor: white;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\tz-index: 2;\n\t\t\t\topacity: 0;\n\t\t\t\ttransition: opacity 0.2s ease-in-out;\n\t\t\t}\n\n\t\t\tinput[type='checkbox']:checked::before {\n\t\t\t\topacity: 1;\n\t\t\t}\n\n\t\t\t.button {\n\t\t\t\tmin-width: 230px;\n\t\t\t\tpadding: 10px 10px;\n\t\t\t\tcursor: pointer;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 8px;\n\n\t\t\t\t&.files {\n\t\t\t\t\tcolor: var(--white-color);\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\twidth: 320px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 10px;\n\t\t\t\t\tuser-select: none;\n\t\t\t\t\tbackground: var(--_16c098-color);\n\t\t\t\t\tborder-radius: 4px;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground: var(--_16c09821-background);\n\t\t\t\t\t}\n\n\t\t\t\t\tp {\n\t\t\t\t\t\tmargin: 0px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.copy {\n\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t}\n\n\t\t\t\t&.stripe {\n\t\t\t\t\tborder: 1px solid var(--_10a37f-background);\n\t\t\t\t\tborder-radius: 4px;\n\n\t\t\t\t\tstrong {\n\t\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.inactive {\n\t\t\t\t\tborder: 1px solid var(--_10a37f-background);\n                    border-radius: 4px;\n                    background: transparent;\n                    color: var(--_10a37f-background);\n                    opacity: 0.5;\n\t\t\t\t}\n\n\t\t\t\t&.active {\n\t\t\t\t\tborder: 1px solid var(--_10a37f-background);\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\ta {\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n\n\n.customButton {\n\twidth: 320px;\n\theight: 40px;\n\tborder: none;\n\tcursor: pointer;\n\t-webkit-user-select: none;\n\tuser-select: none;\n\tcolor: var(--white-color);\n\tbackground: var(--_16c098-color);\n\tborder-radius: 4px;\n\n\t&:hover {\n\t\tbackground: var(--_16c09821-background);\n\t}\n}\n\n.customButtonOutlined {\n\twidth: 320px;\n\theight: 40px;\n\tcursor: pointer;\n\t-webkit-user-select: none;\n\tuser-select: none;\n\tcolor: var(--e6fff9-background);\n\tborder: none;\n\tbackground: var(--_16c098-color);\n\tborder-radius: 4px;\n\n\t&:hover {\n\t\tborder: 1px solid var(--_16c098-background);\n\t\tcolor: var(--_16c098-background);\n\t}\n}\n\n.meeting {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: flex-start;\n\talign-items: center;\n\tflex-direction: column;\n\tgap: 4px;\n\theight: 45px;\n\twidth: 100%;\n\n\tb {\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t}\n\n\t.input {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\t\tjustify-content: center;\n\t\theight: 100%;\n\t\tbackground: var(--border-color);\n\t\tborder-radius: 6px;\n\t\tpadding: 4px 8px;\n\n\t\tsvg {\n\t\t\tmin-height: 16px;\n\t\t\tmin-width: 16px;\n\t\t\twidth: 16px;\n\t\t}\n\n\t\tinput {\n\t\t\twidth: 100%;\n\t\t\tfont-size: 16px;\n\t\t\tbackground: transparent;\n\t\t}\n\t}\n}\n\n\n.calendarsList {\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\tcolor: var(--_3c3a3a-color);\n\tgap: 2px;\n\n\tli {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\n\t\t.dot {\n\t\t\tmin-width: 12px;\n\t\t\tmin-height: 12px;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground: var(--_16c0982e-background);\n\t\t}\n\n\t\tspan {\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n}\n\n.calendarCheckbox {\n\tcolor: var(--_16c098-color);\n}\n\n.downloadIcon {\n\tfont-size: 20px;\n\tcolor: var(--f5-background);\n}\n\n.mainColorIcon {\n\tfont-size: 16px;\n\tcolor: var(--_10a37f-background);\n}\n\n.checkboxIcon {\n\tcolor: var(--e6fff9-background);\n}\n\n.checkedButton {\n\tpadding: 3px;\n\tborder-radius: 50%;\n\ttransition:\n\t\tbackground-color 0.2s ease-in-out,\n\t\ttransform 0.2s ease-in-out;\n\tanimation: checkboxCheckedAnimation 0.25s ease;\n\n\t&:hover {\n\t\tbackground-color: var(--f5-background);\n\t}\n}\n\n.removeIcon {\n\tcursor: pointer;\n\ttransition: transform 0.2s ease-in-out;\n}\n\n.removeIcon:hover {\n\ttransform: scale(1.1);\n}\n\n.uncheckedButton {\n\tborder: none;\n\tbackground: transparent;\n\tpadding: 3px;\n\tborder-radius: 50%;\n\ttransition:\n\t\tbackground-color 0.2s ease-in-out,\n\t\ttransform 0.2s ease-in-out;\n\tanimation: checkboxUncheckedAnimation 0.25s ease;\n\n\t&:hover {\n\t\tbackground-color: var(--f5-background);\n\t}\n}\n\n@keyframes checkboxCheckedAnimation {\n\t0% {\n\t\ttransform: scale(0.85);\n\t}\n\n\t50% {\n\t\ttransform: scale(1.1);\n\t}\n\n\t100% {\n\t\ttransform: scale(1);\n\t}\n}\n\n@keyframes checkboxUncheckedAnimation {\n\t0% {\n\t\ttransform: scale(1);\n\t}\n\n\t50% {\n\t\ttransform: scale(1.1);\n\t}\n\n\t100% {\n\t\ttransform: scale(0.85);\n\t}\n}\n\n.checkboxWithInputContainer {\n\tdisplay: flex;\n\tgap: 10px;\n\tflex-direction: row;\n\tjustify-content: flex-start;\n\talign-items: center;\n}\n\n.numberInputCheckbox {\n\tbackground-color: var(--f5-background);\n\tborder-radius: 4px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: none;\n\toutline: none;\n\theight: 45px;\n\twidth: 70px;\n\tcolor: #666;\n\tfont-size: 18px;\n\tpadding: 0px 10px;\n\ttext-decoration: none;\n}\n\n.saveButton {\n\tbackground-color: var(--_16c098-color);\n\twidth: 140px;\n\theight: 40px;\n\tborder: none;\n\tborder-radius: 4px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--white-color);\n\tcursor: pointer;\n\t-webkit-user-select: none;\n\tuser-select: none;\n\ttransition: background 0.2s ease-in-out;\n\n\t&:hover {\n\t\tbackground: var(--_16c09821-background);\n\t}\n}\n\n.submitButton {\n\tbackground-color: var(--_16c09821-background) !important;\n\tborder: none;\n\tborder-radius: 5px;\n\tcolor: var(--white-color);\n\tpadding: 10px 20px;\n\tcursor: pointer;\n\tfont-size: 16px;\n\tposition: relative;\n\toverflow: hidden;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttransition: background-color 0.3s ease;\n}\n\n.calendarAsPublicContent {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\twidth: 100%;\n}\n\n.submitButton.sent {\n\tbackground-color: var(--_16c098-background) !important;\n}\n\n.text {\n\ttransition:\n\t\topacity 0.5s ease,\n\t\ttransform 0.5s ease;\n\topacity: 1;\n\ttransform: translateY(0);\n}\n\n.icon {\n\tposition: absolute;\n\topacity: 0;\n\ttransform: translateY(-20px);\n\ttransition:\n\t\topacity 0.5s ease,\n\t\ttransform 0.5s ease;\n}\n\n.submitButton.sent .text {\n\topacity: 0;\n\ttransform: translateY(20px);\n}\n\n.submitButton.sent .icon {\n\topacity: 1;\n\ttransform: translateY(0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settings": `settings_txzT9`,
	"left": `left_dZZHa`,
	"active": `active_EC3UT`,
	"right": `right_ToPus`,
	"content": `content_UHwvM`,
	"container": `container_s2PgD`,
	"small": `small_BDCAu`,
	"input": `input_dCP0y`,
	"title": `title_ATVjC`,
	"list": `list_CKXxE`,
	"notification": `notification_ykzvx`,
	"access": `access_cyD1j`,
	"events": `events_AR8Cp`,
	"checkbox": `checkbox_lCruV`,
	"button": `button__gPG7`,
	"files": `files_SxDQf`,
	"copy": `copy_EWv9b`,
	"stripe": `stripe_S3HQJ`,
	"inactive": `inactive_ed3Kc`,
	"customButton": `customButton_oq6G4`,
	"customButtonOutlined": `customButtonOutlined_Oy1Dc`,
	"meeting": `meeting_KHNWP`,
	"calendarsList": `calendarsList_GAgkr`,
	"dot": `dot_PTLlX`,
	"calendarCheckbox": `calendarCheckbox_Tbafu`,
	"downloadIcon": `downloadIcon_pVwQz`,
	"mainColorIcon": `mainColorIcon_qpFFG`,
	"checkboxIcon": `checkboxIcon_pUjW0`,
	"checkedButton": `checkedButton_jR8Hv`,
	"checkboxCheckedAnimation": `checkboxCheckedAnimation__gCNz`,
	"removeIcon": `removeIcon_PnseX`,
	"uncheckedButton": `uncheckedButton_V3HQy`,
	"checkboxUncheckedAnimation": `checkboxUncheckedAnimation_E4c1F`,
	"checkboxWithInputContainer": `checkboxWithInputContainer_CFsU9`,
	"numberInputCheckbox": `numberInputCheckbox_Qo5Eh`,
	"saveButton": `saveButton_Ko8lj`,
	"submitButton": `submitButton_QdYA0`,
	"calendarAsPublicContent": `calendarAsPublicContent_YvKyq`,
	"sent": `sent_DVNwW`,
	"text": `text_DcHeX`,
	"icon": `icon_a6HWu`
};
export default ___CSS_LOADER_EXPORT___;
